import { SearchChatsData } from "@sms/shared/chat/search/search.interface";
import { Reducer, combineReducers, Action } from "redux";
import { createReducer, PayloadAction } from "typesafe-actions";

import {
  updateSearchResultsDataAction,
  setIsLoadingSearchAction,
  switchSearchWrapperAction,
  updateSearchResultsDataToDefaultEmptyAction
} from "./search.actions";

const defaultValueSearchResults: SearchChatsData = {
  chatsByName: [],
  chatsByMessage: []
};

export interface SearchStore {
  searchResults: SearchChatsData;
  isOpenSearchWrapper: boolean;
  isLoading: boolean | null;
}

export const SearchReducers: Reducer<SearchStore> = combineReducers({
  searchResults: createReducer<SearchChatsData, Action>(defaultValueSearchResults)
    .handleAction(
      updateSearchResultsDataAction,
      (_: SearchChatsData, { payload }: PayloadAction<string, SearchChatsData>) => payload
    )
    .handleAction(updateSearchResultsDataToDefaultEmptyAction, () => defaultValueSearchResults),
  isOpenSearchWrapper: createReducer<boolean, Action>(false).handleAction(
    switchSearchWrapperAction,
    (_: boolean, { payload }: PayloadAction<string, boolean>) => payload
  ),
  isLoading: createReducer<boolean | null, Action>(null).handleAction(
    setIsLoadingSearchAction,
    (_: boolean | null, { payload }: PayloadAction<string, boolean | null>) => payload
  )
});
